import React, { useState } from 'react';
import { Button } from './Button';
import { Instagram, Twitter, Facebook, Youtube, Mail, Phone, MapPin, ArrowRight, Palette, CheckCircle, Loader2 } from 'lucide-react';
export const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState('idle'); // idle, loading, success
  const handleSubscribe = e => {
    e.preventDefault();
    if (!email) return;
    setSubscribeStatus('loading');
    // Simulate API call
    setTimeout(() => {
      setSubscribeStatus('success');
      setTimeout(() => {
        setSubscribeStatus('idle');
        setEmail('');
      }, 3000);
    }, 1500);
  };
  return <footer id="contact" className="bg-gradient-to-br from-[#00b8c4] to-[#0097a0] text-white scroll-mt-20" data-id="element-40">
      {/* Newsletter Section */}
      <div className="container mx-auto px-4 py-12" data-id="element-41">
        <div className="bg-white rounded-xl p-8 shadow-xl -mt-20 mb-12 relative z-10" data-id="element-42">
          <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-43">
            <div className="mb-6 md:mb-0 md:mr-8" data-id="element-44">
              <h3 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-45">
                Stay in the loop!
              </h3>
              <p className="text-gray-600" data-id="element-46">
                Subscribe to our newsletter for exclusive deals and sticker
                inspiration.
              </p>
            </div>
            <form className="w-full md:w-auto flex flex-col sm:flex-row gap-3" onSubmit={handleSubscribe} data-id="element-47">
              <div className="relative" data-id="element-48">
                <input type="email" placeholder="Your email address" className="px-4 py-3 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#00b8c4] w-full md:w-64" value={email} onChange={e => setEmail(e.target.value)} disabled={subscribeStatus !== 'idle'} data-id="element-49" />
                {subscribeStatus === 'success' && <span className="absolute right-4 top-1/2 transform -translate-y-1/2" data-id="element-50">
                    <CheckCircle className="h-5 w-5 text-green-500" data-id="element-51" />
                  </span>}
              </div>
              <Button className="whitespace-nowrap" type="submit" disabled={subscribeStatus !== 'idle'} data-id="element-52">
                {subscribeStatus === 'loading' ? <>
                    <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-53" />
                    Subscribing...
                  </> : subscribeStatus === 'success' ? <>
                    <CheckCircle className="mr-2 h-5 w-5" data-id="element-54" />
                    Subscribed!
                  </> : <>
                    Subscribe
                    <ArrowRight className="ml-2 h-5 w-5" data-id="element-55" />
                  </>}
              </Button>
            </form>
          </div>
        </div>
        {/* Start Designing CTA */}
        <div className="bg-[#ffcc29] rounded-xl p-8 shadow-xl mb-12 text-center relative overflow-hidden" data-id="element-56">
          <div className="max-w-3xl mx-auto relative z-10" data-id="element-57">
            <h3 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-58">
              Ready to create your custom stickers?
            </h3>
            <p className="text-gray-700 mb-6 text-lg" data-id="element-59">
              Turn your ideas into high-quality stickers that stand out. Our
              easy-to-use design tool makes it simple!
            </p>
            <Button size="large" className="flex items-center mx-auto group hover:scale-105 transition-transform duration-300" data-id="element-60">
              <Palette className="mr-2 h-5 w-5 group-hover:animate-spin" data-id="element-61" />
              Start Designing
            </Button>
          </div>
          {/* Decorative elements */}
          <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-[#ff6b6b] opacity-20" data-id="element-62"></div>
          <div className="absolute -left-8 -bottom-8 h-32 w-32 rounded-full bg-[#00b8c4] opacity-20" data-id="element-63"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 py-8" data-id="element-64">
          {/* Company Info */}
          <div data-id="element-65">
            <h4 className="text-xl font-bold mb-4" data-id="element-66">StickerJoy</h4>
            <p className="mb-4 text-gray-100" data-id="element-67">
              Creating high-quality, custom stickers that bring your ideas to
              life since 2015.
            </p>
            <div className="flex space-x-4" data-id="element-68">
              <a href="#" className="hover:text-[#ffcc29] transition-colors transform hover:scale-110 transition-transform duration-300" aria-label="Instagram" data-id="element-69">
                <Instagram className="h-5 w-5" data-id="element-70" />
              </a>
              <a href="#" className="hover:text-[#ffcc29] transition-colors transform hover:scale-110 transition-transform duration-300" aria-label="Twitter" data-id="element-71">
                <Twitter className="h-5 w-5" data-id="element-72" />
              </a>
              <a href="#" className="hover:text-[#ffcc29] transition-colors transform hover:scale-110 transition-transform duration-300" aria-label="Facebook" data-id="element-73">
                <Facebook className="h-5 w-5" data-id="element-74" />
              </a>
              <a href="#" className="hover:text-[#ffcc29] transition-colors transform hover:scale-110 transition-transform duration-300" aria-label="Youtube" data-id="element-75">
                <Youtube className="h-5 w-5" data-id="element-76" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-77">
            <h4 className="text-xl font-bold mb-4" data-id="element-78">Quick Links</h4>
            <ul className="space-y-2" data-id="element-79">
              <li data-id="element-80">
                <a href="#" className="hover:text-[#ffcc29] transition-colors hover:translate-x-1 inline-block transform transition-transform duration-200" data-id="element-81">
                  Home
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="hover:text-[#ffcc29] transition-colors hover:translate-x-1 inline-block transform transition-transform duration-200" data-id="element-83">
                  Shop
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="hover:text-[#ffcc29] transition-colors hover:translate-x-1 inline-block transform transition-transform duration-200" data-id="element-85">
                  Customize
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-[#ffcc29] transition-colors hover:translate-x-1 inline-block transform transition-transform duration-200" data-id="element-87">
                  Bulk Pricing
                </a>
              </li>
              <li data-id="element-88">
                <a href="#" className="hover:text-[#ffcc29] transition-colors hover:translate-x-1 inline-block transform transition-transform duration-200" data-id="element-89">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-90">
            <h4 className="text-xl font-bold mb-4" data-id="element-91">Contact Us</h4>
            <ul className="space-y-3" data-id="element-92">
              <li className="flex items-start hover:translate-x-1 transform transition-transform duration-200" data-id="element-93">
                <Mail className="h-5 w-5 mr-2 mt-0.5" data-id="element-94" />
                <span data-id="element-95">support@stickerjoy.com</span>
              </li>
              <li className="flex items-start hover:translate-x-1 transform transition-transform duration-200" data-id="element-96">
                <Phone className="h-5 w-5 mr-2 mt-0.5" data-id="element-97" />
                <span data-id="element-98">(555) 123-4567</span>
              </li>
              <li className="flex items-start hover:translate-x-1 transform transition-transform duration-200" data-id="element-99">
                <MapPin className="h-5 w-5 mr-2 mt-0.5" data-id="element-100" />
                <span data-id="element-101">123 Sticky Street, Design District, CA 90210</span>
              </li>
            </ul>
          </div>
          {/* Support */}
          <div data-id="element-102">
            <h4 className="text-xl font-bold mb-4" data-id="element-103">Support</h4>
            <ul className="space-y-2" data-id="element-104">
              <li data-id="element-105">
                <a href="#" className="hover:text-[#ffcc29] transition-colors hover:translate-x-1 inline-block transform transition-transform duration-200" data-id="element-106">
                  Help Center
                </a>
              </li>
              <li data-id="element-107">
                <a href="#" className="hover:text-[#ffcc29] transition-colors hover:translate-x-1 inline-block transform transition-transform duration-200" data-id="element-108">
                  Shipping Info
                </a>
              </li>
              <li data-id="element-109">
                <a href="#" className="hover:text-[#ffcc29] transition-colors hover:translate-x-1 inline-block transform transition-transform duration-200" data-id="element-110">
                  Returns & Refunds
                </a>
              </li>
              <li data-id="element-111">
                <a href="#" className="hover:text-[#ffcc29] transition-colors hover:translate-x-1 inline-block transform transition-transform duration-200" data-id="element-112">
                  Track Your Order
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Bottom Bar */}
      <div className="border-t border-[#00a0aa]" data-id="element-113">
        <div className="container mx-auto px-4 py-6 flex flex-col md:flex-row justify-between items-center" data-id="element-114">
          <p className="text-sm mb-4 md:mb-0" data-id="element-115">
            © 2023 StickerJoy. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-116">
            <a href="#" className="text-sm hover:text-[#ffcc29] transition-colors" data-id="element-117">
              Privacy Policy
            </a>
            <a href="#" className="text-sm hover:text-[#ffcc29] transition-colors" data-id="element-118">
              Terms of Service
            </a>
            <a href="#" className="text-sm hover:text-[#ffcc29] transition-colors" data-id="element-119">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>;
};